export class SocialShareRuntimeElement extends HTMLElement {

    static get observedAttributes(): string[] {
        return ['params'];
    }

    private setListeners(): void {
        this.parentElement.addEventListener('click', (event: MouseEvent): void => {
            const target: HTMLElement = (<HTMLElement>event.target).closest('.social-wrapper button');
            if (target) {
                event.stopPropagation();
                const share: string = target.getAttribute('data-share');
                switch (share) {
                    case 'copy-link': {
                        this.shareCopyLink();
                        break;
                    }
                    case 'facebook': {
                        this.shareFacebook();
                        break;
                    }
                    case 'linkedIn': {
                        this.shareLinkedIn();
                        break;
                    }
                    case 'mail': {
                        this.shareMail();
                        break;
                    }
                    case 'twitter': {
                        this.shareTwitter();
                        break;
                    }
                    case 'xing': {
                        this.shareXing();
                        break;
                    }
                    default: {
                        console.error('[Social Share] Sharing type not detected. Nothing to do here.');
                    }
                }
            }
        });
        this.parentElement.querySelector('.social-trigger').addEventListener('click', () => {
            this.parentElement.classList.toggle('open');
        });
    }

    public connectedCallback(): void {
        this.setListeners();
    }

    public disconnectedCallback(): void {
    }

    private shareCopyLink(): void {
        navigator.clipboard.writeText(encodeURI(window.location.href));
    }

    private shareFacebook(): void {
        window.open(`https://www.facebook.com/sharer.php?u=${encodeURIComponent(window.location.href)}`, 'social_share', 'width=500,height=500');
    }

    private shareLinkedIn(): void {
        window.open(`https://www.linkedin.com/shareArticle/?mini=true&url=${encodeURIComponent(window.location.href)}`, 'social_share', 'width=500,height=500');
    }

    private shareMail(): void {
        let title = document.querySelector('meta[name="title"]')?.textContent;
        if (!title) {
            // fallback on document.title
            title = document.querySelector('title')?.textContent;
        }
        window.location.href = `mailto:?subject=${title || ''}&body=${encodeURIComponent(window.location.href)}`;
    }

    private shareTwitter(): void {
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(window.location.href)}`, 'social_share', 'width=500,height=500');
    }

    private shareXing(): void {
        window.open(`https://www.xing.com/spi/shares/new?url=${encodeURIComponent(window.location.href)}`, 'social_share', 'width=500,height=500');
    }
}